export const fireRegisterEvent = () => {
  window.uetq = window.uetq || [];
  window.uetq.push({ ea: 'register', ev: 1 });
};
